import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/settings-checked.svg'
import _imports_1 from '@/assets/settings-unchecked.svg'


_pushScopeId("data-v-5029510a")
const _hoisted_1 = { class: "settings-tool-component" }
const _hoisted_2 = { id: "settings-wrap" }
const _hoisted_3 = { class: "settings" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "checked" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "unchecked" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1)
const _hoisted_6 = {
  class: "slide",
  ref: "guidelinesSlide"
}
const _hoisted_7 = {
  type: "checkbox",
  ref: "guidelinesInput",
  hidden: ""
}
const _hoisted_8 = { class: "settings" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "checked" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "unchecked" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1)
const _hoisted_11 = {
  class: "slide",
  ref: "rulersSlide"
}
const _hoisted_12 = {
  type: "checkbox",
  ref: "rulersInput",
  hidden: ""
}
const _hoisted_13 = { class: "settings" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "checked" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "unchecked" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1)
const _hoisted_16 = {
  class: "slide",
  ref: "gridSlide"
}
const _hoisted_17 = {
  type: "checkbox",
  ref: "gridInput",
  hidden: ""
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTitle = _resolveComponent("ToolTitle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ToolTitle, { title: _ctx.title }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClick($event, 'guidelines')))
        }, " Show Guidelines "),
        _createElementVNode("div", {
          class: "settings-input",
          id: "guidelines",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClick($event, 'guidelines')))
        }, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, null, 512),
          _createElementVNode("input", _hoisted_7, null, 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleClick($event, 'rulers')))
        }, "Show Rulers"),
        _createElementVNode("div", {
          class: "settings-input",
          id: "rulers",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleClick($event, 'rulers')))
        }, [
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, null, 512),
          _createElementVNode("input", _hoisted_12, null, 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleClick($event, 'grid')))
        }, "Snap to Grid"),
        _createElementVNode("div", {
          class: "settings-input",
          id: "grid",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleClick($event, 'grid')))
        }, [
          _hoisted_14,
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, null, 512),
          _createElementVNode("input", _hoisted_17, null, 512)
        ])
      ])
    ])
  ]))
}